import { render, staticRenderFns } from "./agentDetail.vue?vue&type=template&id=4daf71ec&scoped=true"
import script from "./agentDetail.vue?vue&type=script&lang=js"
export * from "./agentDetail.vue?vue&type=script&lang=js"
import style0 from "./agentDetail.vue?vue&type=style&index=0&id=4daf71ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daf71ec",
  null
  
)

export default component.exports